import React from 'react';

export const OutlookPcDesktopUnread = ({ customizedUnreadClassName }) => (
  <div className={customizedUnreadClassName}>
    <div className="unread-flag" />
    <svg className="unread-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.64645 3.14645C5.45118 3.34171 5.45118 3.65829 5.64645 3.85355L9.79289 8L5.64645 12.1464C5.45118 12.3417 5.45118 12.6583 5.64645 12.8536C5.84171 13.0488 6.15829 13.0488 6.35355 12.8536L10.8536 8.35355C11.0488 8.15829 11.0488 7.84171 10.8536 7.64645L6.35355 3.14645C6.15829 2.95118 5.84171 2.95118 5.64645 3.14645Z" fill="#0F6CBD" />
    </svg>
  </div>
);

export const OutlookMobileWebUnread = ({ customizedUnreadClassName }) => (
  <svg className={customizedUnreadClassName} width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4.5C0 2.29086 1.79086 0.5 4 0.5C6.20914 0.5 8 2.29086 8 4.5C8 6.70914 6.20914 8.5 4 8.5C1.79086 8.5 0 6.70914 0 4.5Z" fill="#0F6CBD" />
  </svg>
);
